import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { NavLink, useNavigate, useParams } from "react-router-dom";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { useTheme } from "@emotion/react";
import StorageIcon from '@mui/icons-material/Storage';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import RequestPageOutlinedIcon from '@mui/icons-material/RequestPageOutlined';
import useAuth from "../hooks/use-auth";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { ROLE } from "../constants";
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const Sidebar = () => {
    const { protector } = useAuth()
    const theme = useTheme();
    const params = useParams()
    const navigate = useNavigate()

    return (
        <Box flex={1} sx={{ display: { xs: "none", md: "block" }, height: "100%", pr: { md: 1, lg: 2 }, position: "relative" }} >
            <List className={"sidebar_active"}>
                {!(params.id === 'create' || params.draftId)
                    ?
                    <>
                        <NavLink to={'/'} style={{ color: theme.palette.primary.contrastText }}>
                            <ListItem disablePadding sx={{ mb: '5px' }}>
                                <ListItemButton disableRipple sx={{ borderRadius: "0 8px 8px 0", "&:hover": { backgroundColor: '#ffffff17' } }}>
                                    <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                                        <DashboardOutlinedIcon sx={{ color: theme.palette.primary.contrastText }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Dashboard" />
                                </ListItemButton>
                            </ListItem>
                        </NavLink>
                        <NavLink to={'/jobs'} style={{ color: theme.palette.primary.contrastText }}>
                            <ListItem disablePadding sx={{ mb: '5px' }}>
                                <ListItemButton disableRipple sx={{ borderRadius: "0 8px 8px 0", "&:hover": { backgroundColor: '#ffffff17' } }}>
                                    <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                                        <WorkOutlineOutlinedIcon sx={{ color: theme.palette.primary.contrastText }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Jobs" />
                                </ListItemButton>
                            </ListItem>
                        </NavLink>
                        {/* <NavLink to={'/reports'} sx={{ color: theme.palette.primary.contrastText }}>
                    <ListItem disablePadding sx={{ mb: '5px' }}>
                        <ListItemButton sx={{ borderRadius:"0 8px 8px 0" }}>
                            <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                                <AssessmentOutlinedIcon sx={{ color: theme.palette.primary.contrastText }}/>
                            </ListItemIcon >
                            <ListItemText primary="Report" />
                        </ListItemButton>
                    </ListItem>
                </NavLink> */}
                        {
                            protector([
                                ROLE.sa,
                                ROLE.admin,
                                ROLE.client,
                            ]) && <NavLink to={'/invoices'} style={{ color: theme.palette.primary.contrastText }}>
                                <ListItem disablePadding sx={{ mb: '5px' }}>
                                    <ListItemButton disableRipple sx={{ borderRadius: "0 8px 8px 0", "&:hover": { backgroundColor: '#ffffff17' } }}>
                                        <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                                            <DescriptionOutlinedIcon sx={{ color: theme.palette.primary.contrastText }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Invoices" />
                                    </ListItemButton>
                                </ListItem>
                            </NavLink>}
                        {
                            protector([
                                ROLE.client,
                            ]) && <NavLink to={'/wallet'} style={{ color: theme.palette.primary.contrastText }}>
                                <ListItem disablePadding sx={{ mb: '5px' }}>
                                    <ListItemButton disableRipple sx={{ borderRadius: "0 8px 8px 0", "&:hover": { backgroundColor: '#ffffff17' } }}>
                                        <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                                            <MonetizationOnOutlinedIcon sx={{ color: theme.palette.primary.contrastText }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Wallet" />
                                    </ListItemButton>
                                </ListItem>
                            </NavLink>}
                        {
                            protector([
                                ROLE.client,
                            ]) && <NavLink to={'/transaction'} style={{ color: theme.palette.primary.contrastText }}>
                                <ListItem disablePadding sx={{ mb: '5px' }}>
                                    <ListItemButton disableRipple sx={{ borderRadius: "0 8px 8px 0", "&:hover": { backgroundColor: '#ffffff17' } }}>
                                        <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                                            <RequestPageOutlinedIcon sx={{ color: theme.palette.primary.contrastText }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Transaction" />
                                    </ListItemButton>
                                </ListItem>
                            </NavLink>}
                        {
                            protector([
                                ROLE.sa,
                                ROLE.admin,
                            ]) && <NavLink to={'/user'} style={{ color: theme.palette.primary.contrastText }}>
                                <ListItem disablePadding sx={{ mb: '5px' }}>
                                    <ListItemButton disableRipple sx={{ borderRadius: "0 8px 8px 0", "&:hover": { backgroundColor: '#ffffff17' } }}>
                                        <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                                            <PersonOutlineIcon sx={{ color: theme.palette.primary.contrastText }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Users" />
                                    </ListItemButton>
                                </ListItem>
                            </NavLink>
                        }
                        {/* <NavLink to={'/services'} sx={{ color: theme.palette.primary.contrastText }}>
                    <ListItem disablePadding>
                        <ListItemButton sx={{ borderRadius:"0 8px 8px 0" }}>
                            <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                                <MiscellaneousServicesIcon />
                            </ListItemIcon>
                            <ListItemText primary="Services" />
                        </ListItemButton>
                    </ListItem>
                </NavLink> */}
                        {
                            protector([
                                ROLE.client,
                            ]) &&
                            <NavLink to={'/photosettings'} style={{ color: theme.palette.primary.contrastText }}>
                                <ListItem disablePadding sx={{ mb: '5px' }}>
                                    <ListItemButton disableRipple sx={{ borderRadius: "0 8px 8px 0", "&:hover": { backgroundColor: '#ffffff17' } }}>
                                        <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                                            <ImageOutlinedIcon sx={{ color: theme.palette.primary.contrastText }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Photo Settings" />
                                    </ListItemButton>
                                </ListItem>
                            </NavLink>
                        }
                        {
                            protector([
                                ROLE.client,
                            ]) &&
                            <NavLink to={'/storage'} style={{ color: theme.palette.primary.contrastText }}>
                                <ListItem disablePadding sx={{ mb: '5px' }}>
                                    <ListItemButton disableRipple sx={{ borderRadius: "0 8px 8px 0", "&:hover": { backgroundColor: '#ffffff17' } }}>
                                        <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                                            <StorageIcon sx={{ color: theme.palette.primary.contrastText }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Storage" />
                                    </ListItemButton>
                                </ListItem>
                            </NavLink>
                        }
                        {
                            protector([
                                ROLE.sa,
                                ROLE.admin,
                            ]) && <NavLink to={'/admin'} style={{ color: theme.palette.primary.contrastText }}>
                                <ListItem disablePadding sx={{ mb: '5px' }}>
                                    <ListItemButton disableRipple sx={{ borderRadius: "0 8px 8px 0", "&:hover": { backgroundColor: '#ffffff17' } }}>
                                        <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                                            <ManageAccountsOutlinedIcon sx={{ color: theme.palette.primary.contrastText }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Admin Settings" />
                                    </ListItemButton>
                                </ListItem>
                            </NavLink>
                        }
                        <NavLink to={'/accounts/profile'} style={{ color: theme.palette.primary.contrastText }}>
                            <ListItem disablePadding sx={{ mb: '5px' }}>
                                <ListItemButton disableRipple sx={{ borderRadius: "0 8px 8px 0", "&:hover": { backgroundColor: '#ffffff17' } }}>
                                    <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                                        <AccountCircleOutlinedIcon sx={{ color: theme.palette.primary.contrastText }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Profile" />
                                </ListItemButton>
                            </ListItem>
                        </NavLink>
                        {protector([ROLE.editor, ROLE.qc]) &&
                            <NavLink to={'/report'} style={{ color: theme.palette.primary.contrastText }}>
                                <ListItem disablePadding sx={{ mb: '5px' }}>
                                    <ListItem disablePadding>
                                        <ListItemButton disableRipple sx={{ borderRadius: "0 8px 8px 0", "&:hover": { backgroundColor: '#ffffff17' } }}>
                                            <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                                                <AssessmentOutlinedIcon sx={{ color: theme.palette.primary.contrastText }} />
                                            </ListItemIcon>
                                            <ListItemText primary="Report" />
                                        </ListItemButton>
                                    </ListItem>
                                </ListItem>
                            </NavLink>
                        }
                        {/* <ListItem disablePadding>
                    <ListItemButton
                        disableRipple
                        sx={{ borderRadius: "0 8px 8px 0" , "&:hover": { backgroundColor: '#ffffff17' } }}
                        onClick={(e) => {
                            e.stopPropagation()
                            dispatch(uiActions.setDarkMode(!current_theme))
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                            {current_theme ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
                        </ListItemIcon>
                        <ListItemText primary="Theme" />
                    </ListItemButton>
                </ListItem> */}
                    </>
                    :
                    <ListItem disablePadding sx={{ mb: '5px' }}>
                        <ListItemButton disableRipple sx={{ borderRadius: "0 8px 8px 0", "&:hover": { backgroundColor: '#ffffff17' } }}
                            onClick={() => { navigate('/jobs') }}
                        >
                            <ListItemIcon sx={{ minWidth: { xs: "35px", xl: "56px" } }}>
                                <ArrowBackIcon sx={{ color: theme.palette.primary.contrastText }} />
                            </ListItemIcon>
                            <ListItemText primary="Back to Jobs page" sx={{ color: "white" }} />
                        </ListItemButton>
                    </ListItem>
                }
            </List>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignContent: "end", }}>
                <Typography sx={{ fontSize: "14px", position: "absolute", bottom: "6px", left: "6px", color: theme.palette.primary.contrastText }}>App Version</Typography>
                <Typography sx={{ fontSize: "14px", position: "absolute", bottom: "6px", right: "6px", color: theme.palette.primary.contrastText }}>V{process.env.REACT_APP_VERSION}</Typography>
            </Box>
        </Box>
    )
}

export default Sidebar